import { http } from '../utils/http';
import Paging from '../interfaces/common/paging';
import FactorSetVersionOut from '../interfaces/output/factorSetVersionOut';
import FactorSetVersionIn from '../interfaces/input/factorSetVersionIn';
import FactorSetPriorityLineOut from '../interfaces/output/factorSetPriorityLineOut';
import FactorSetPriorityLineIn from '../interfaces/input/factorSetPriorityLineIn';
import SortFormatterUtils from '../utils/sortFormatterUtils';

export default class FactorSetPriorityVersionApi {
    static fetchFactorSetPriorityVersionById = async(factorSetVersionId: string): Promise<FactorSetVersionOut> => {
        const { data } = await http.get<FactorSetVersionOut>(`factorsets/priority/versions/${factorSetVersionId}`);

        return data;
    };

    static fetchFactorSetPriorityVersions = async(factorId: number, paging: Paging): Promise<Array<FactorSetVersionOut>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, `/factorsets/priority/${factorId}/versions`);
        const { data } = await http.get<Array<FactorSetVersionOut>>(url);

        return data;
    };

    static createFactorSetPriorityVersionLines= async(versionLine: FactorSetPriorityLineOut): Promise<FactorSetPriorityLineOut> => {
        const newLine: FactorSetPriorityLineIn = {
            name: versionLine.name,
            priorityTypeId: versionLine.priorityType?.id,
            factor: versionLine.factor,
            surcharge: versionLine.surcharge
        };

        const { data } = await http.post<FactorSetPriorityLineIn, FactorSetPriorityLineOut>( `factorsets/priority/versions/${versionLine.factorSetVersionId}/lines`, newLine);

        return data;
    }

    static updateFactorSetPriorityVersionStatus = async(factorSetVersion: FactorSetVersionOut): Promise<FactorSetVersionOut> => {
        
        const { data } = await http.put<FactorSetVersionIn, FactorSetVersionOut>(`factorsets/priority/versions/${factorSetVersion.id}/status/${factorSetVersion.status?.id}`);

        return data;
    }

    static updateFactorSetPriorityVersion = async(factorSetVersion: FactorSetVersionOut): Promise<FactorSetVersionOut> => {
        const newVersion: FactorSetVersionIn = {
            validFromDate: factorSetVersion.validFromDate,
            validToDate: factorSetVersion.validToDate,
            statusId: factorSetVersion.status?.id
        };
        
        const { data } = await http.put<FactorSetVersionIn, FactorSetVersionOut>(`factorsets/priority/versions/${factorSetVersion.id}`, newVersion);

        return data;
    }

    static cloneFactorSetPriorityVersion = async(toVersionId: number, fromVersionId: number): Promise<FactorSetVersionOut> => {
        
        const { data } = await http.put<FactorSetVersionIn, FactorSetVersionOut>(`factorsets/priority/versions/${toVersionId}/copyFrom/${fromVersionId}`);

        return data;
    }
}